/**
 * @file src/components/organisms/YieldBearingAssetPerformanceDetail/YieldBearingAssetAdvancedDetailsButton.tsx
 * @description This file defines the YieldBearingAssetAdvancedDetailsButton component which provides a button to view advanced details about a yield-bearing asset.
 * It integrates YieldBearingAssetAdvancedDetailsTray for viewing detailed information.
 * @module YieldBearingAssetAdvancedDetailsButton
 */

import { Button } from '@/components/atoms';
import { YieldBearingAssetInterface } from '@/interfaces';
import { FC, useState } from 'react';
import YieldBearingAssetAdvancedDetailsTray from './YieldBearingAssetAdvancedDetailsTray';

interface YieldBearingAssetAdvancedDetailsButtonProps {
  asset: YieldBearingAssetInterface;
}

const YieldBearingAssetAdvancedDetailsButton: FC<
  YieldBearingAssetAdvancedDetailsButtonProps
> = ({ asset }) => {
  const [isTrayOpen, setIsTrayOpen] = useState<boolean>(false);

  const openAdvancedDetailsTray = () => {
    setIsTrayOpen(true);
  };

  return (
    <>
      <Button
        icon="information"
        intent={'ghost'}
        onClick={openAdvancedDetailsTray}
        iconStyles={{ intent: 'accent' }}
        flexHeight
      />
      <YieldBearingAssetAdvancedDetailsTray
        isOpen={isTrayOpen}
        onClose={() => setIsTrayOpen(false)}
        asset={asset}
      />
    </>
  );
};

export default YieldBearingAssetAdvancedDetailsButton;
